/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Modal } from "react-bootstrap";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import FormInput from "../FormInput";
import { qreq } from "../../shared/qrequest";
import Icon from "../Icon";

class SurveyAdminImportModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
        this.submit = this.submit.bind(this);
    }

    submit(e) {
        if(e) e.preventDefault();
        this.setState({ submitting: true });
        const doSubmit = surveyID => {
            qreq.post('/api/survey/import', {...this.state.info, surveyID: surveyID }, j => {
                if(j.errorCode === 0) {
                    this.success('Questions successfully imported.');
                    this.setState({ info: {} });
                    if(this.props.onSubmit)
                        this.props.onSubmit();
                    if(this.props.onHide)
                        this.props.onHide();
                }
                else
                    this.alert(j.errorMessage);
                this.setState({ submitting: false });
            }, () => {
                this.unkownErrorCallback();
                this.setState({ submitting: false });
            });
        };
        if(this.props.preImport)
            this.props.preImport(surveyID => {
                doSubmit(surveyID);
            });
        else
            doSubmit(this.props.surveyID);
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide} size="xl">
            <Modal.Header>
                Import Questions
            </Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    <FormInput model={this.state.info} name="content" label="Import Text" type="textarea" required rows={10} disabled={this.state.submitting} />
                    {this.state.submitting ? <div className="mt-3">Importing... Please wait...</div> : ''}
                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="btn btn-success btn-lg" disabled={this.state.submitting}><Icon icon="faFileArrowUp" /> Import</button>
                    <button type="button" className="btn btn-secondary btn-lg" onClick={this.props.onHide} disabled={this.state.submitting}><Icon icon="faCancel" /> Cancel</button>
                </Modal.Footer>
            </form>
        </Modal>;
    }
}

export default withParamsAndNavigate(SurveyAdminImportModal);